import MitForm from '../components/Form/Form'
import { Container } from '@mui/material'

const styles = {
  container: {
    padding: '32px 16px',
    maxWidth: '1024px'
  },
  header: {
    fontWeight: 700,
    fontSize: '34px',
    fontFamily: 'NeueHaasDisplayBold',
    lineHeight: '42.5px',
    letterSpacing: '0%',
    marginBottom: '32px'
  },
  subHeader: {
    fontSize: '17px',
    color: 'rgba(0, 0, 0, 1)',
    fontFamily: 'NHaasGroteskTXPro-65Rg',
    marginBottom: '16px'
  },
  description: {
    fontWeight: 400,
    fontSize: '17px',
    color: 'rgba(0, 0, 0, 0.75)',
    fontFamily: 'NHaasGroteskTXPro-55Rg',
    marginBottom: '16px'
  }
}

export function Unsubscribe() {
  return (
    <Container style={styles.container}>
      <div style={styles.header}>Unsubscribe from Commencement week text notifications</div>
      <div style={styles.description}>
        Use the form below to unsubscribe from MIT 2025 Commencement week text notifications. Note that you can unsubscribe from notifications for specific ceremonies or from all notifications. You can always resubscribe using the <a href="/">sign-up</a> form if you wish.
      </div>
      <MitForm isUnsubscribe={true} />
      <div className="resubscribe-wrapper">
        <a className="resubscribe" href="/">
          Subscribe Instead?
        </a>
      </div>
    </Container>
  )
}
